"use client"

import { useEffect, useState } from "react"
import { useSearchParams } from "next/navigation"

import Register from "@modules/account/components/register"
import Login from "@modules/account/components/login"

export enum LOGIN_VIEW {
  SIGN_IN = "sign-in",
  REGISTER = "register",
}

const viewFromSearchParams = (searchParams: URLSearchParams) =>
  searchParams.get("view") === "register" ? LOGIN_VIEW.REGISTER : LOGIN_VIEW.SIGN_IN

const LoginTemplate = () => {
  const searchParams = useSearchParams()
  const [currentView, setCurrentView] = useState<LOGIN_VIEW>(() =>
    viewFromSearchParams(searchParams)
  )

  // The header's Sign In / Create an Account links both point at this same
  // route, differing only by the `view` query param. Next.js reuses this
  // component instance across that navigation (no remount), so the tab must
  // be resynced explicitly whenever the URL's view param changes.
  useEffect(() => {
    setCurrentView(viewFromSearchParams(searchParams))
  }, [searchParams])

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4 sm:px-8 py-12">
      <div className="w-full max-w-md">
        {/* Tabs */}
        <div className="flex border-b border-gray-200 mb-8">
          <button
            onClick={() => setCurrentView(LOGIN_VIEW.REGISTER)}
            className={`flex-1 pb-3 text-sm font-medium text-center transition-colors ${
              currentView === LOGIN_VIEW.REGISTER
                ? "text-brand-accent border-b-2 border-brand-accent"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            New to UKSS?
          </button>
          <button
            onClick={() => setCurrentView(LOGIN_VIEW.SIGN_IN)}
            className={`flex-1 pb-3 text-sm font-medium text-center transition-colors ${
              currentView === LOGIN_VIEW.SIGN_IN
                ? "text-brand-accent border-b-2 border-brand-accent"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Already Registered?
          </button>
        </div>

        {currentView === LOGIN_VIEW.SIGN_IN ? (
          <Login setCurrentView={setCurrentView} />
        ) : (
          <Register setCurrentView={setCurrentView} />
        )}
      </div>
    </div>
  )
}

export default LoginTemplate
